import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { reduxForm, InjectedFormProps, change, Field } from 'redux-form';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { Modal } from 'components';
import { PortalPageSectionItemSelector } from 'components/PortalPage/SectionItems/SectionItemSelector';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { Button } from 'components';
import { onCloseModalForm } from 'helpers/common';
import { ButtonsSection, PortalPageSection, TwoColumnPage } from 'components/PortalStructure';
import { PortalInputField } from 'components/FormControls';
import { required, maxLength } from 'helpers/validationattributes';

require('./../../style.css');
require('components/Tabs/style.css');

const maxLength255 = maxLength(255);

interface IProps extends InjectedFormProps {
	section: IPortalPageSection;
	baseUrl?: string;
	currentFormValues: IPortalPageSection;
	showHeaderCloseButton: boolean;
	index: number;
	inline?: boolean;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	change?: (field: any, value: any) => void;
	saveSection?: (form: IPortalPageSection, index?: number) => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType2Form extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	private onSubmit(form: IPortalPageSection) {
		const getImageUrl = (data: IPortalPageSection['items'][number]) => (data.elements?.[0] as any)?.imageUrl;
		const itemWithImage = form.items.find(getImageUrl);
		form.seoImageUrl = itemWithImage ? getImageUrl(itemWithImage) : '';
		this.props.saveSection(form, this.props.index);
	}

	private onChange(field: string, value: any) {
		this.props.change(field, value);
		this.forceUpdate();
	}

	private closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	public render() {
		const {
			pristine,
			submitting,
			handleSubmit,
			t,
			showHeaderCloseButton,
			showModal,
			closeModal,
			currentFormValues,
			baseUrl,
			section,
			inline,
		} = this.props;

		const disableTypes: Array<typeof c.PORTAL_PAGE_SECTION_ITEM_POLL> = [c.PORTAL_PAGE_SECTION_ITEM_POLL];

		const item1Props = {
			change: this.onChange,
			index: 1,
			currentFormValues,
			section,
			showModal,
			closeModal,
			baseUrl,
			disableTypes,
		};

		const item2Props = {
			change: this.onChange,
			index: 2,
			currentFormValues,
			section,
			showModal,
			closeModal,
			baseUrl,
			disableTypes,
		};

		const item3Props = {
			change: this.onChange,
			index: 3,
			currentFormValues,
			section,
			showModal,
			closeModal,
			baseUrl,
			disableTypes,
		};

		const tabs = (
			<>
				<PortalPageSection usage="admin">
					<div className="row">
						<div className="col-md-12">
							<Field
								name={`items[0].elements[0].text`}
								component={PortalInputField}
								usage="admin"
								type="text"
								label={t('Administration_MenuItem_ManageMenuItem_Label_Title')}
								validate={[required, maxLength255]}
							/>
						</div>
					</div>
				</PortalPageSection>
				<br />
				<Tabs name="sectionItemSelectorTabs" tabComponent="div">
					<div className="tabsHolder">
						<TabLink className="tab" to="box1">
							{t('Magazine_Section_Manage_Common_Label_Box') + ' '}1
						</TabLink>
						<TabLink className="tab" to="box2">
							{t('Magazine_Section_Manage_Common_Label_Box') + ' '}2
						</TabLink>
						<TabLink className="tab" to="box3">
							{t('Magazine_Section_Manage_Common_Label_Box') + ' '}3
						</TabLink>
					</div>
					<br />
					<div className="tabsContent">
						<TabContent for="box1">
							<PortalPageSectionItemSelector {...item1Props} />
						</TabContent>
						<TabContent for="box2">
							<PortalPageSectionItemSelector {...item2Props} />
						</TabContent>
						<TabContent for="box3">
							<PortalPageSectionItemSelector {...item3Props} />
						</TabContent>
					</div>
				</Tabs>
			</>
		);

		if (inline) {
			const buttons = (
				<ButtonsSection>
					<div className="row">
						<div className="col-sm-12">
							<Button
								type="button"
								usage="admin"
								disabled={pristine || submitting}
								onClick={handleSubmit(this.onSubmit)}
							>
								{t('BSPortal_Common_Save')}
							</Button>
						</div>
					</div>
				</ButtonsSection>
			);
			return <TwoColumnPage leftColumnContent={tabs} rightColumnContent={buttons} />;
		}

		return (
			<Modal
				title={t('PortalPage_Section_Manage_Common_EditSection')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
				modalClass="portalPageSectionManageWrapper"
			>
				<form onSubmit={handleSubmit(this.onSubmit)}>
					{tabs}
					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<Button type="submit" usage="admin" disabled={pristine || submitting}>
									{t('BSPortal_Common_SaveAndClose')}
								</Button>
							</div>
						</div>
					</ButtonsSection>
				</form>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	const newProps = {
		type: c.PORTAL_PAGE_SECTION_TYPE_2,
		items: [],
	};

	let currentFormValues: IPortalPageSection = null;
	if (state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION2] && state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION2].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION2].values;
	}

	return {
		initialValues: ownProps.section || newProps,
		currentFormValues,
	};
}

let ManageType2 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION2,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType2Form);

ManageType2 = connect(mapStateToProps, (dispatch) => ({
	change: (field: string, value: string) => dispatch(change(field, value)),
}))(ManageType2);

export { ManageType2 };
